import React, { useContext } from "react";
import { Typography, Box } from "@mui/material";
import { ErrorMessage, Field, FastField } from "formik";
import TextError from "../TextError";
import useFormikInput from "../FormikInput/useFormikInput";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import CustomInfoTooltip from "../CustomInfoTooltip/CustomInfoTooltip";

function FormikInput() {
  const field = useContext(FormikControlContext);
  const {
    label,
    arrObjName,
    name,
    validation,
    dataType,
    readOnly,
    hintText,
    infoText,
  } = field;

  const { handleChange, handleBlur, validate } = useFormikInput();

  const InputField = readOnly === undefined ? Field : FastField;

  return (
    <>
      <Typography>
        <Box display="flex" alignItems="center" component="span">
          {label}
          {validation?.required && <span>*</span>}
          {infoText && <CustomInfoTooltip message={infoText} />}
        </Box>
      </Typography>
      <InputField
        as="input"
        className="form-control"
        id={name}
        disabled={Boolean(readOnly)}
        name={name}
        placeholder={hintText || label}
        type={dataType}
        onChange={handleChange}
        onBlur={handleBlur}
        onWheel={(e) =>
          dataType.toLowerCase() === "number" ? e.currentTarget.blur() : null
        }
        required={validation?.required ?? false}
        validate={validate}
      />
      <ErrorMessage name={name} component={TextError} />
    </>
  );
}

export default FormikInput;
